import { render, staticRenderFns } from "./ReferencesUniversal.vue?vue&type=template&id=3ca0b59c&scoped=true"
import script from "./ReferencesUniversal.vue?vue&type=script&lang=js"
export * from "./ReferencesUniversal.vue?vue&type=script&lang=js"
import style0 from "./ReferencesUniversal.vue?vue&type=style&index=0&id=3ca0b59c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca0b59c",
  null
  
)

export default component.exports